module.exports = __webpack_public_path__ + "media/components/video_discovery/assets/Back_to_Deseret_Book-a16e00c3fbd90a9f8976e2370aae348e.svg";